import script from "./CreatorChatInlineVideoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorChatInlineVideoPlayer.vue?vue&type=script&setup=true&lang=js"

import "./CreatorChatInlineVideoPlayer.vue?vue&type=style&index=0&id=48ad65b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ad65b3"]])

export default __exports__